import { QSetStatusTag } from '@exam-management/components';
import type { QSet } from '@exam-management/graphql';
import { EllipsisText, Flex, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { MoreActionMenu } from '../more-action-menu';

interface ReviewedQSetColumn {
  id: QSet['id'];
  code: QSet['code'];
  status: QSet['status'];
  lastReviewedAt: QSet['lastReviewedAt'];
  qConfig: {
    code: QSet['qConfig']['code'];
    name: QSet['qConfig']['name'];
  };
  reviewers: QSet['assignees'];
}

export const columns: GridColDef<ReviewedQSetColumn>[] = [
  {
    field: 'code',
    headerName: 'QSet ID',
    sortable: false,
    minWidth: 112,
    flex: 1,
    renderCell: (params) => {
      return <EllipsisText>{params.row.code}</EllipsisText>;
    },
  },
  {
    field: 'qConfig.name',
    headerName: 'QConfig Name',
    sortable: false,
    flex: 1,
    minWidth: 206,
    renderCell: (params) => {
      return <EllipsisText>{params.row.qConfig.name}</EllipsisText>;
    },
  },
  {
    field: 'qConfig.code',
    headerName: 'QConfig ID',
    sortable: false,
    width: 120,
    renderCell: (params) => {
      return <EllipsisText>{params.row.qConfig.code}</EllipsisText>;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: false,
    flex: 1,
    minWidth: 206,
    renderCell: (params) => {
      return <QSetStatusTag status={params.row.status} size='large' />;
    },
  },
  {
    field: 'lastReviewedAt',
    headerName: 'Submitted Date',
    flex: 1,
    minWidth: 206,
    renderCell: (params) => {
      const { lastReviewedAt } = params.row;
      return <>{lastReviewedAt ? formatDateTime(lastReviewedAt) : '-'}</>;
    },
  },
  {
    field: 'reviewers',
    headerName: 'Reviewer',
    flex: 1,
    minWidth: 206,
    renderCell: (params) => {
      const reviewers = params.row.reviewers;
      const reviewerList = reviewers.length
        ? reviewers.map((reviewer) => reviewer.firstname + ' ' + reviewer.lastname)
        : ['-'];

      return (
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(2) }}>
          {reviewerList.map((reviewer) => (
            <EllipsisText key={`qset-reviewer-${reviewer}`}>{reviewer}</EllipsisText>
          ))}
        </Flex>
      );
    },
  },
  {
    field: 'moreAction',
    headerName: '',
    width: 48,
    sortable: false,
    renderCell: (params) => <MoreActionMenu qSetId={params.row.id} status={params.row.status} />,
  },
];
